import * as React from 'react';
import { useIntl } from 'react-intl';
import { observer } from 'mobx-react-lite';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Settings from '@mui/icons-material/Settings';
import { NutritionProductPlan } from '../../services/PlansService';
import NutritionProductsList from './NutritionProductsList';
import NutritionProductsTable from '../plans/NutritionProductsTable';

interface NutritionProductsSectionProps {
  nutrition: NutritionProductPlan[];
  setNutrition: (nutrition: NutritionProductPlan[]) => void;
  showAddFavorite?: boolean;
}

const NutritionProductsSection: React.FC<NutritionProductsSectionProps> = observer(({
  nutrition,
  setNutrition,
  showAddFavorite = false
}) => {
  const intl = useIntl();
  const [nutritionTableOpen, setNutritionTableOpen] = React.useState(false);

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={1}>
        <Typography variant="body2" fontWeight="bold">
          {intl.formatMessage({ id: 'plans.nutritionTitle' })}
        </Typography>
        <Button startIcon={<Settings />} onClick={() => setNutritionTableOpen(true)} size="small">
          {intl.formatMessage({ id: 'plans.nutritionProducts' })}
        </Button>
      </Box>

      <NutritionProductsList
        nutrition={nutrition}
        setNutrition={setNutrition}
        showAddFavorite={showAddFavorite}
        onOpenProductsTable={() => setNutritionTableOpen(true)}
      />

      <Dialog open={nutritionTableOpen} onClose={() => setNutritionTableOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>{intl.formatMessage({ id: 'plans.nutritionProducts' })}</DialogTitle>
        <DialogContent>
          <NutritionProductsTable />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNutritionTableOpen(false)}>
            {intl.formatMessage({ id: 'action.close' })}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

export default NutritionProductsSection;
